<div class="dropdown-text">
  {{ placeholder }}
</div>
<div class="dropdown-arrow">&#9662;</div>

@if (dropdownVisible) {
  <div class="dropdown-items">
    <ng-content></ng-content>
    <div class="dropdown-arrow top"></div>
  </div>
}
